module.exports = __webpack_public_path__ + "img/google-pixel.f3bb196b.png";